export default __webpack_public_path__ + "static/media/Macrobac-500-Tab-eng.c5c291cb.jpg";